module.exports = __webpack_public_path__ + "img/Clear_Filled_12px_Icon-black.7c7d7724.svg";